import React, { Fragment } from "react";
import __ from "lodash";
import {useQueryClient} from "react-query";
import { Icon, makeStyles, Tooltip} from "@material-ui/core";
import { ActionButton } from "./controls";
import { HandshakeIcon } from "../../../icons";
import { useFlights } from "../../../services/flights";
import useColour from "../../../services/settings/useColour";
import AirplaneLandingIcon from "../../../icons/AirplaneLandingIcon";
import AirplaneTakeoffIcon from "../../../icons/AirplaneTakeoffIcon";
import TripToolTipStyles from "../TripToolTipStyles";
import { useAuth0 } from "@auth0/auth0-react";
import { useTripLegServices } from "../../../services/trips";
import SupplierName from "./SupplierName";

const AccessControl = require ("../../../AccessControl");

const ServicesScreen = (props) => {
  const {tripData, eventBus} = props; 

  const classes = makeStyles(TripToolTipStyles)();
  const { user } = useAuth0();
  const canUpdateServices = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS"]);

  const queryClient = useQueryClient();
  const extraKeys = [tripData.uuid];
  const flight = useFlights({queryClient, extraKeys});
  const tripLegServices = useTripLegServices({queryClient, extraKeys});

  const ServiceRow = (props) => {
    const {data, airportCode} = props;
    const backgroundColor = useColour({code: 'SERVICES BACKGROUND', status: data.serviceProviderUuid?"CONFIRMED":"REQUIRED"});
    const color = useColour({code: 'SERVICES TEXT', status: data.serviceProviderUuid?"CONFIRMED":"REQUIRED"});
    const role = data.companyRole;
    return (
      <div className={classes.serviceRow} style={{backgroundColor, color}}>
        <div style={{fontWeight: "700", display: "inline-block", width: "43%", verticalAlign: "top"}}>{data.serviceName}:</div>
        <div style={{display: "inline-block", width: "calc(57% - 20px)", verticalAlign: "top"}}>
          <SupplierName companyType={data.serviceCompanyType} companyUuid={data.serviceProviderUuid} airportCode={airportCode} role={role}/>
        </div>        
        <div style={{display: data.serviceNotes?"inline-block":"none", float:"right", verticalAlign: "top"}}><Tooltip title={data.serviceNotes}><Icon style={{fontSize: "14px"}}>description</Icon></Tooltip></div>
      </div>
    );
  }

  let inboundServices = [];
  let outboundServices = [];
  if (tripLegServices && Array.isArray(tripLegServices.data) && tripLegServices.data.length > 0) {
    const services = tripLegServices.data;
    inboundServices = __.filter(services, (service) => service.direction === 'IN' && Boolean(service.isRequired) === true);
    outboundServices = __.filter(services, (service) => service.direction === 'OUT' && Boolean(service.isRequired) === true);
  } 

  const NoServicesDefined = (props) => {
    return (
      <>
        <div className={classes.serviceDirectionHeader}>
          <div style={{display: "inline-block"}}><AirplaneTakeoffIcon style={{position: "relative", top: 2, width: 16, height: 16}}/></div>
          <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Outbound Services Required</div>
        </div>
        <div style={{height: 15}}></div>
        <div className={classes.serviceDirectionHeader}>
          <div style={{display: "inline-block"}}><AirplaneLandingIcon style={{position: "relative", top: 2, width: 16, height: 16}}/></div>
          <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Inbound Services Required</div>
        </div>
      </>
    )
  }

  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><HandshakeIcon style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Services</div>
      {canUpdateServices?
        <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
          <ActionButton 
            variant="outlined" 
            startIcon={<Icon>edit</Icon>}
            onClick={()=>{
              if (Array.isArray(flight.data) && flight.data.length)
                eventBus.trigger("RouteView.TimeWindow.TripAction.editServices",{tripData: {...flight.data[0]}, extraKeys, canUpdateServices});
            }}
          >
            Edit
          </ActionButton>
        </div>
      :
        <></>
      }
    </div>
    <div style={{width: "100%"}}>
      {tripLegServices && Array.isArray(tripLegServices.data) && tripLegServices.data.length > 0?
        <>
          <div className={classes.serviceDirectionHeader}>
            <div style={{display: "inline-block"}}><AirplaneTakeoffIcon style={{position: "relative", top: 2, width: 16, height: 16}}/></div>
            <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Outbound Services Required</div>
          </div>
          {outboundServices.length > 0?
            outboundServices.map(serviceData => (
              <ServiceRow 
                data={serviceData}
                airportCode={tripData.originAirportCode}
              />
            ))
          : null}
          <div style={{height: 15}}></div>
          <div className={classes.serviceDirectionHeader}>
            <div style={{display: "inline-block"}}><AirplaneLandingIcon style={{position: "relative", top: 2, width: 16, height: 16}}/></div>
            <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Inbound Services Required</div>
          </div>
          {inboundServices.length > 0?
            inboundServices.map(serviceData => (
              <ServiceRow 
                data={serviceData}
                airportCode={tripData.destinationAirportCode}
              />
            ))
          : null}
        </>
      : 
        <NoServicesDefined/>
      }
    </div>
  </Fragment>); 
}

export default ServicesScreen;